module.exports = __webpack_public_path__ + "img/multiplier1_normal.3ca2e2e9.png";